// src/lib/LeafletIconsPatch.tsx
'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    __leafletIconPatched?: boolean;
  }
}

export default function LeafletIconsPatch() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.__leafletIconPatched) return;

    (async () => {
      // ✅ correct typing: no `.default`
      const L = (await import('leaflet')) as typeof import('leaflet');

      // These imports resolve to string URLs via the bundler
      const marker2x = (await import('leaflet/dist/images/marker-icon-2x.png')).default;
      const marker   = (await import('leaflet/dist/images/marker-icon.png')).default;
      const shadow   = (await import('leaflet/dist/images/marker-shadow.png')).default;

      // Some builds define _getIconUrl — guard deletion
      const DefaultIcon: any = L.Icon.Default;
      if (DefaultIcon?.prototype?._getIconUrl) {
        delete DefaultIcon.prototype._getIconUrl;
      }

      L.Icon.Default.mergeOptions({
        iconRetinaUrl: marker2x,
        iconUrl: marker,
        shadowUrl: shadow,
      });

      window.__leafletIconPatched = true;
    })();
  }, []);

  return null;
}
